import { render, staticRenderFns } from "./HuePaletteWell.vue?vue&type=template&id=2f0c30b6&scoped=true&"
import script from "./HuePaletteWell.vue?vue&type=script&lang=js&"
export * from "./HuePaletteWell.vue?vue&type=script&lang=js&"
import style0 from "./HuePaletteWell.vue?vue&type=style&index=0&id=2f0c30b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c30b6",
  null
  
)

export default component.exports